import { useState, useEffect, useMemo } from 'react';
import { LOTTO_CONSTANTS } from '../constants';
import { toLottoMillis, calcTimeDiffAndFormatToString } from '../utils/date';

export const useCountdownTimer = ({
  targetDate,
  status = 'ACTIVE',
  intervalMs = LOTTO_CONSTANTS.COUNTDOWN_INTERVAL_MS,
}) => {
  const [countdown, setCountdown] = useState(null);
  const [currentTime, setCurrentTime] = useState(Date.now());

  const isExpired = useMemo(() => {
    if (!targetDate) return true;
    return currentTime >= toLottoMillis(targetDate);
  }, [targetDate, currentTime]);

  useEffect(() => {
    if (!targetDate || status !== 'ACTIVE') {
      setCountdown(null);
      return undefined;
    }

    const targetMillis = toLottoMillis(targetDate);

    const updateCountdown = () => {
      if (Number.isNaN(targetMillis)) {
        setCountdown(null);
        return;
      }

      setCurrentTime(Date.now());
      const formatted = calcTimeDiffAndFormatToString(targetMillis, true);
      setCountdown(formatted === '00s' ? null : formatted);
    };

    updateCountdown();
    const timerId = window.setInterval(updateCountdown, intervalMs);

    return () => window.clearInterval(timerId);
  }, [targetDate, status, intervalMs]);

  return { countdown, currentTime, isExpired };
};
